import { HomePage, DisplayDataPage, ProfilePage } from "./pages";
import JurosBox from "./pages/JurosBox";
import CalendarioIssBox from "./pages/CalendarioIssBox";
import CategoriaCpbxBox from "./pages/CategoriaCpbsBox";
import ServicosIssBox from "./pages/servicosIss/ServicosIssBox";
import ContadorBox from "./pages/contadores/ContadorBox";
import ContadorForm from "./pages/contadores/ContadorForm";
import MultasBox from "./pages/MultasBox";
import BairrosBox from "./pages/BairrosBox";
import DistritosBox from "./pages/DistritosBox";
import EscoresBox from "./pages/EscoresBox";
import AliquotasIPTUBox from "./pages/AliquotasIPTUBox";
import LogradourosBox from "./pages/LogradourosBox";
import LoteamentosBox from "./pages/LoteamentosBox";
import ColaboradoresBox from "./pages/ColaboradoresBox";
import CategoriasAliquotasIssBox from "./pages/CategoriasAliquotasIssBox";
import SituacoesCadastraisCpbsBox from "./pages/SituacoesCadastraisCpbsBox";
import RegimesTributariosBox from "./pages/RegimesTributariosBox";
import TiposRecolhimentoBox from "./pages/TiposRecolhimentoBox";
import GrausInstrucaoBox from "./pages/GrausIntrucaoBox";
import NaturezasJuridicasBox from "./pages/NaturezasJuridicasBox";
import CnaesBox from "./pages/CnaesBox";
import FeriadosBox from "./pages/FeriadosBox";
import PrefeituraBox from "./pages/prefeituras/PrefeituraBox";
import PrefeituraForm from "./pages/prefeituras/PrefeituraForm";
import ServicosLCPBox from "./pages/ServicosLCPBox";
import CategoriasLCPBox from "./pages/CategoriasLCPBox";
import NaturezasOperacaoBox from "./pages/NaturezasOperacaoBox";
import SerieNotaFiscalBox from "./pages/SerieNotaFiscalBox";
import RetencaoExternaBox from "./pages/RetencaoExternaBox";
import CadastrarLeisBox from "./pages/CadastrarLeisBox";
import DocumentosRetencaoBox from "./pages/DocumentosRetencaoBox";
import CpbsBox from "./pages/cpbs/CpbsBox";
import CpbsForm from "./pages/cpbs/CpbsForm";
import TextoCdaBox from "./pages/textoCda/TextoCdaBox";
import TextoCdaForm from "./pages/textoCda/TextoCdaForm";
import AgentesRecebedoresBox from "./pages/AgentesRecebedoresBox";
import TiposVeiculosBox from "./pages/TiposVeiculosBox";
import SituacaoDividaBox from "./pages/SituacaoDividaBox";
import TipoNotificacaoBox from "./pages/tipoNotificacao/TipoNotificacaoBox";
import TipoNotificacaoForm from "./pages/tipoNotificacao/TipoNotificacaoForm";
import VeiculosBox from "./pages/veiculos/VeiculosBox";
import VeiculosForm from "./pages/veiculos/VeiculosForm";
import ContasBancariasBox from "./pages/contasBancarias/ContasBancariasBox";
import ContasBancariasForm from "./pages/contasBancarias/ContasBancariasForm";
import ReceitasBox from "./pages/receitas/ReceitasBox";
import ReceitasForm from "./pages/receitas/ReceitasForm";
import UnidadeFiscalBox from "./pages/UnidadeFiscalBox";
import ContribuinteBox from "./pages/contribuintes/ContribuinteBox";
import ContribuinteForm from "./pages/contribuintes/ContribuinteForm";
import ParametrosRefisBox from "./pages/parametosRefis/ParametrosRefisBox";
import ParametrosRefisForm from "./pages/parametosRefis/ParametrosRefisForm";
import IndicePrecosBox from "./pages/IndicePrecosBox";
import SegmentosBox from "./pages/segmentos/SegmentosBox";
import SegmentosForm from "./pages/segmentos/SegmentosForm";
import FatoresCorretivosBox from "./pages/fatoresCorretivos/FatoresCorretivosBox";
import FatoresCorretivosForm from "./pages/fatoresCorretivos/FatoresCorretivosForm";
import TaxasBox from "./pages/taxas/TaxasBox";
import TaxasForm from "./pages/taxas/TaxasForm";
import ConfiguracaoCndBox from "./pages/configuracaoCnd/ConfiguracaoCndBox";
import ConfiguracaoCndForm from "./pages/configuracaoCnd/ConfiguracaoCndForm";
import MotivoIsensaoIptuBox from "./pages/MotivoIsensaoIptuBox";
import ImovelBox from "./pages/imovel/ImovelBox";
import ImovelForm from "./pages/imovel/ImovelForm";
import DiatBox from "./pages/dividaAtiva/DiatBox";
import DiatForm from "./pages/dividaAtiva/DiatForm";
import NotificacaoDiatBox from "./pages/notificacaoDivida/NotificacaoDiatBox";
import NotificacaoDiatForm from "./pages/notificacaoDivida/NotificacaoDiatForm";
import EntregaNotificacaoDiatBox from "./pages/EntregaNotificacaoDivida/EntregaNotificacaoDiatBox";
import EntregaNotificacaoDiatForm from "./pages/EntregaNotificacaoDivida/EntregaNotificacaoDiatForm";
import CuboImoveis from "./pages/cuboImoveis/CuboImoveis";
import RelatoriosDisplay from "./pages/RelatoriosDisplay";
import ArrecadacaoPopup from "./pages/ArrecadacaoPopup";
import ImoveisInativosPopup from "./pages/ImoveisInativosPopup";
import ImprimirImoveisPopup from "./pages/ImprimirImoveisPopup";
import RelatoriosFiltros from "./pages/RelatoriosFiltros";
import FormEditTerreno from "./pages/imovel/options/infoTerreno";
import FormEditEdificacao from "./pages/imovel/options/infoEdificacao";
import AlvaraVeiculoForm from "./pages/lancamentos/AlvaraVeiculo";
import DamsBox from "./pages/DamsBox";
import CefsBox from "./pages/CefsBox";
import AlvarasBox from "./pages/lancamentos/AlvarasBox";
import EnviarArquivoProcessamento from "./pages/EnviarArquivoProcessamento";
import LancamentoIptu from "./pages/lancamentos/lancamentoIptu/LancamentoIptuBox";
import ImprimirIptu from "./pages/iptu/ImprimirIptu";
import ParametrosIptuBox from "./pages/parametrosIptu/ParamIptuBox";
import ParametrosIptuForm from "./pages/parametrosIptu/ParamIptuForm";
import BaixaManualForm from "./pages/BaixaManual";
import BaixarNotas from "./pages/lancamentos/BaixarNotas";
import TipoUsoLogradouroBox from "./pages/TipoUsoLogradouroBox";
import TiposAlvaraConstrucaoForm from "./pages/tiposAlvaraConstrucao/TiposAlvaraConstrucaoForm";
import TiposAlvaraConstrucaoBox from "./pages/tiposAlvaraConstrucao/TiposAlvaraConstrucaoBox";
import TipoAlvaraDiversoForm from "./pages/tipoAlvaraDiverso/TipoAlvaraDiversoForm";
import TipoAlvaraDiversoBox from "./pages/tipoAlvaraDiverso/TipoAlvaraDiversoBox";
import LancamentoAlvaraHorarioEspecial from "./pages/alvaras/LancamentoAlvaraHorarioEspecial";
import LancamentoUsoLogradouroPublico from "./pages/alvaras/LancamentoUsoLogradouroPublico";
import LancamentoAlvaraPublicidade from "./pages/alvaras/LancamentoAlvaraPublicidade";
import LancamentoAlvaraDiversos from "./pages/alvaras/LancamentoAlvaraDiversos";
import LancamentoAlvaraConstrucao from "./pages/alvaras/LancamentoAlvaraConstrucao";
import ItbiForm from "./pages/itbi/ItbiForm";
import NegociacaoDiat from "./pages/negociacaoDividaAtiva/NegociacaoDiat";
import CnaePrefeituraBox from "./pages/cnaePrefeitura/CnaePrefeituraBox";
import CnaePrefeituraForm from "./pages/cnaePrefeitura/CnaePrefeituraForm";
import Lcp116PrefeituraBox from "./pages/lcp116Prefeitura/Lcp116PrefeituraBox";
import Lcp116PrefeituraForm from "./pages/lcp116Prefeitura/Lcp116PrefeituraForm";
import CategoriaLcp116PrefeituraBox from "./pages/CategoriaLcp116PrefeituraBox";
import AlvaraFuncionamentoForm from "./pages/lancamentos/AlvaraFuncionamentoForm";
import SociosBox from "./pages/cpbs/Socios/SociosBox";
import SociosForm from "./pages/cpbs/Socios/SociosForm";
import FormulasBox from "./pages/formulasIptu/FormulasBox";
import FormulasForm from "./pages/formulasIptu/FormulasForm";
import QualificacaoSociosBox from "./pages/QualificacaoSociosBox";
import ConfigBox from "./pages/ConfigBox";
import PrecoPublicoBox from "./pages/precoPublico/PrecoPublicoBox";
import PrecoPublicoForm from "./pages/precoPublico/PrecoPublicoForm";
import PermissionarioBox from "./pages/permissionario/PermissionarioBox";
import PermissionarioForm from "./pages/permissionario/PermissionarioForm";
import ResponsavelTecnicoBox from "./pages/responsavelTecnico/ResponsavelTecnicoBox";
import ResponsavelTecnicoForm from "./pages/responsavelTecnico/ResponsavelTecnicoForm";
import ArrecadacaoGeral from "./pages/relatorios/ArrecadacaoGeral";
import ArrecadacaoReceita from "./pages/relatorios/ArrecadacaoReceita";
import ArrecadacaoContabilidade from "./pages/relatorios/ArrecadacaoContabilidade";
import RelacaoDividaAtiva from "./pages/relatorios/RelacaoDividaAtiva";
import CertidaoNegativaBox from "./pages/certidaoNegativa/CertidaoNegativaBox";
import CertidaoNegativaForm from "./pages/certidaoNegativa/CertidaoNegativaForm";
import CertidaoNegativaAutomatica from "./pages/certidaoNegativa/CertidaoNegativaAutomatica";
import VisualizarCertidao from "./pages/certidaoNegativa/VisualizarCertidao";
import ItbiBox from "./pages/itbi/ItbiBox";
import LancamentoTaxasForm from "./pages/lancamentoTaxas/LancamentoTaxasForm";
import LancamentoTaxasBox from "./pages/lancamentoTaxas/LancamentoTaxasBox";
import ValorEdificadoBox from "./pages/valorEdificado/ValorEdificadoBox";
import ValorEdificadoForm from "./pages/valorEdificado/ValorEdificadoForm";
import AcompanhamentoDiatBox from "./pages/AcompanhamentoDiatBox";
import NotaFiscalAvulsaBox from "./pages/notaFiscalAvulsa/NotaFiscalAvulsaBox";
import NotaFiscalAvulsaForm from "./pages/notaFiscalAvulsa/NotaFiscalAvulsaForm";
import CdaBox from "./pages/cda/CdaBox";
import CnaesCpbsBox from "./pages/cpbs/Cnaes/CnaesCpbsBox";
import Habitese from "./pages/habitese/habitese";
import DetalheLanchamento from "./pages/lancamentos/DetalheLancamento";
import AcompanharProcessamento from "./pages/processamentos/AcompanharProcessamento";
import ListarProcessamento from "./pages/processamentos/ListarProcessamentos";
import DetalheNFAvulsa from "./pages/notaFiscalAvulsa/DetalheNFAvulsa";
import CdaForm from "./pages/cda/CdaForm";
import ServicosIssForm from "./pages/servicosIss/ServicosIssForm";
import ConferenciaAcordo from "./pages/ConferenciaAcordo";
import PrescricaoDiat from "./pages/PrescricaoDiat";
import FaturamentoPermissionarios from "./pages/permissionario/FaturamentoPermissionarios";
import ProtocoloEntregaNotificacao from "./pages/notificacaoDivida/ProtocoloEntregaNotificacaoForm";
import CadastroProcessamentosTeste from "./pages/CadastroProcessamentosTeste";
import UsuariosBox from "./pages/usuarios/UsuariosBox";
import UsuariosForm from "./pages/usuarios/UsuariosForm";
import AnaliseGraficos from "./pages/analises/analiseGraficos";
import EnviarAcessosEmMassa from "./pages/EnviarAcessoEmMassa";
import ArquivosEBoletos from "./pages/ArquivosEBoletos";
import FerramentasNFSe from "./pages/Ferramentas NFS-e";
import MenuConfiguracoes from "./pages/menuConfiguracoes/MenuConfiguracoes";
import ContasCosifBox from "./pages/contasCosif/ContasCosifBox";
import ContasCosifForm from "./pages/contasCosif/ContasCosifForm";
import UploadFiles from "./pages/uploadFiles/UploadFiles";
import ExtratoDebitos from "./pages/relatorios/ExtratoDebitos";
import NfseBox from "./pages/NfseBox";
import NfseGradeBox from "./pages/NfseGradeBox";
import PainelImobiliarioBox from "./pages/PainelImobiliarioBox";
import CalculoManualDiatBox from "./pages/calculoManualDiat/CalculoManualDiatBox";
import CalculoManualDiatForm from "./pages/calculoManualDiat/CalculoManualDiatForm.js";
import UsuariosPrefeituraBox from "./pages/usuariosPrefeitura/usuariosPrefeitura";
import RecursoBox from "./pages/recurso/RecursoBox.js";
import RecursoForm from "./pages/recurso/RecursoForm.js";
import GrupoRecursoBox from "./pages/grupoRecurso/GrupoRecursoBox.js";
import GrupoRecursoForm from "./pages/grupoRecurso/GrupoRecursoForm.js";
import StatusProtocoloBox from "./pages/statusProtocolo/StatusProtocoloBox.js";
import StatusProtocoloForm from "./pages/statusProtocolo/StatusProtocoloForm.js";
import SetorAtendimentoProtocoloForm from "./pages/setorAtendimentoProtocolo/SetorAtendimentoProtocoloForm.js";
import SetorAtendimentoProtocoloBox from "./pages/setorAtendimentoProtocolo/SetorAtendimentoProtocoloBox.js";
import TipoProtocoloBox from "./pages/tipoProtocolo/TipoProtocoloBox.js";
import TipoProtocoloForm from "./pages/tipoProtocolo/TipoProtocoloForm.js";
import AuditoriaBox from "./pages/AuditoriaBox.js";
import IssFixo from "./pages/issFixo//IssFixo.js";
import PermissoesBox from "./pages/usuariosPrefeitura/PermissoesBox.js";
import ProtocolosBox from "./pages/ProtocolosBox";
import CalculoIptu from "./pages/imovel/options/calculoIptu";
import SimplesNacionalBox from "./pages/SimplesNacionalBox.js";
import ProcedimentoDiat from "./pages/ProcedimentoDiat.js";
import Simulacoes from "./pages/simulacoes";
import GerarLivro from "./pages/GerarLivro.js";
import UnificacaoCadastrosBox from "./pages/UnificacaoCadastrosBox.js";
import ImobelBciBox from "./pages/imovelBci/ImovelBciBox";
import ImovelBciForm from "./pages/imovelBci/ImovelBciForm";
import ImovelBciFatores from "./pages/imovelBci/ImovelBciFatoers";
import PreMigracaoCpbsBox from "./pages/PreMigracaoCpbsBox.js";
import IndicesTrimapBox from "./pages/IndicesTrimapBox.js";
import CalendarioIndicesTrimapBox from "./pages/CalendarioIndicesTrimapBox.js";
import Graficos from "./pages/graficos";
import EncerramentoFiscalManualBox from "./pages/encerramentoFiscal/EncerramentoFiscalManualBox";
import EncerramentoFiscalManualForm from "./pages/encerramentoFiscal/EncerramentoFiscalManualForm";
import ArrecadacaoUnificada from "./pages/relatorios/ArrecadacaoUnificada";
import AcompanhamentoSNBox from "./pages/acompanhamentoSimplesNacional/AcompanhamentoSNBox";
import RelatorioFatDecSn from "./pages/relatorioFatDecSn/relatorioFatDecSn";
import DeclaracoesSimplesNacional from "./pages/declaracoesSimplesNacional/declaracoesSimplesNacional";
import PainelIssBox from "./pages/painelIss/PainelIssBox";
import NotasCpbsNfse from "./pages/notasCpbsNfse/notasCpbsNfse";
import EspelhoCpbsNfse from "./pages/espelhoCpbsNfse/espelhoCpbsNfse";
import RankingNfse from "./pages/relatorioRankingNfse/rankingNfse";
import RelatorioEscrituracoesNfse from "./pages/relatorioEscrituracoesNfse/RelatorioEscrituracoesNfse";
import DiatFormNovo from "./pages/dividaAtiva/DiatFormNovo";
import RegistrarBoletosBox from "./pages/RegistrarBoletosBox";
import LancamentoIptuForm from "./pages/lancamentos/lancamentoIptu/LancamentoIptuForm";
import AcompanharIptu from "./pages/lancamentos/lancamentoIptu/AcompanharIptu";
import TransferenciaAnualDiat from "./pages/diatTransferenciaAnual/TransferenciaAnualDiat";
import ParametrosLivroBox from "./pages/diatLivros/parametrosLivroDiat/ParametrosLivroBox";
import ParametrosLivroForm from "./pages/diatLivros/parametrosLivroDiat/ParametrosLivroForm";
import GerarLivroDiat from "./pages/diatLivros/gerarLivrosDiat/GerarLivroDiat";
import CadastroModelosBox from "./pages/CadastroModelos/CadastroModelosBox";
import CadastroModelosForm from "./pages/CadastroModelos/CadastroModelosForm";
import CadastroModelosPrefeituraBox from "./pages/CadastroModelosPrefeitura/CadastroModelosPrefeituraBox";
import CadastroModelosPrefeituraForm from "./pages/CadastroModelosPrefeitura/CadastroModelosPrefeituraForm";
import ParametrosPixBox from "./pages/parametrosPix/ParametrosPixBox";
import ParametrosPixForm from "./pages/parametrosPix/ParametrosPixForm";
import UsuariosNfseBox from "./pages/cpbs/UsuariosNfse/UsuariosNfseBox";
import UsuariosNfseForm from "./pages/cpbs/UsuariosNfse/UsuariosNfseForm";
import FundamentoLegalBox from "./pages/fundamentoLegal/fundamentoLegalBox";
import FundamentoLegalForm from "./pages/fundamentoLegal/fundamentoLegalForm";
import TransferenciaImovel from "./pages/transferenciaImovel/TransferenciaImovel";
import AlvaraEmLote from "./pages/lancamentos/AlvaraEmLote";
import RestaurarNfseBox from "./pages/RestaurarNfseBox";
import CancelarEscrituracaoBox from "./pages/CancelarEscrituracaoBox";
import AlvarasEmitidos from "./pages/relatorioAlvarasEmitidos/alvarasEmitidos";
import SituacaoDiatBoxNovo from "./pages/SituacaoDiat/SituacaoDiatBoxNovo";
import SituacaoDiatFormNovo from "./pages/SituacaoDiat/SituacaoDiatFormNovo";
import ConferenciaNumeroComplemento from "./pages/ConferenciaNumeroComplemento";
import ConferenciaLogradouro from "./pages/ConferenciaLogradouro";
import UnificarCadastrosForm from "./pages/UnificarCadastrosForm.js";
import blazorWrapper from "./components/blazor-wrapper/blazor-wrapper.js";
import AcessosNfseAntigaBox from "./pages/AcessosNfseAntigaBox.js";
import AdnNfeBox from "./pages/adn/AdnNfeBox";
import ImportarCnpjsTse from "./pages/eleicoes/ImportarCnpjsTse";

export default [
  {
    path: "/display-data",
    component: DisplayDataPage,
  },
  {
    path: "/profile/:id?",
    component: ProfilePage,
  },
  {
    path: "/home",
    component: HomePage,
  },
  {
    path: "/juros",
    perfis: ["trimap", "prefeitura"],
    component: JurosBox,
    recursoId: 1,
  },
  {
    path: "/calendarioIss",
    perfis: ["trimap", "prefeitura"],
    component: CalendarioIssBox,
    recursoId: 2,
  },
  {
    path: "/multas",
    perfis: ["trimap", "prefeitura"],
    component: MultasBox,
    recursoId: 3,
  },
  {
    path: "/categorias_cpbs",
    perfis: ["trimap", "prefeitura"],
    component: CategoriaCpbxBox,
    recursoId: 4,
  },
  {
    tipo: "grade-form",
    path: "/servicosiss",
    perfis: ["trimap", "prefeitura"],
    component: ServicosIssBox,
    componentForm: ServicosIssForm,
    recursoId: 5,
  },
  {
    tipo: "grade-form",
    path: "/contadores",
    perfis: ["trimap", "prefeitura"],
    component: ContadorBox,
    componentForm: ContadorForm,
    recursoId: 6,
  },
  {
    path: "/bairros",
    perfis: ["trimap", "prefeitura"],
    component: BairrosBox,
    recursoId: 7,
  },
  {
    path: "/distritos",
    perfis: ["trimap", "prefeitura"],
    component: DistritosBox,
    recursoId: 8,
  },
  {
    path: "/escores",
    perfis: ["trimap", "prefeitura"],
    component: EscoresBox,
    recursoId: 9,
  },
  {
    path: "/aliquotas_iptu",
    perfis: ["trimap", "prefeitura"],
    component: AliquotasIPTUBox,
    recursoId: 10,
  },
  {
    path: "/logradouros",
    perfis: ["trimap", "prefeitura"],
    component: LogradourosBox,
    recursoId: 11,
  },
  {
    path: "/loteamentos",
    perfis: ["trimap", "prefeitura"],
    component: LoteamentosBox,
    recursoId: 12,
  },
  {
    path: "/colaboradores",
    perfis: ["trimap", "prefeitura"],
    component: ColaboradoresBox,
    recursoId: 13,
  },
  {
    path: "/categorias_servicos",
    perfis: ["trimap", "prefeitura"],
    component: CategoriasAliquotasIssBox,
    recursoId: 14,
  },
  {
    path: "/situacoes_cpbs",
    perfis: ["trimap", "prefeitura"],
    component: SituacoesCadastraisCpbsBox,
    recursoId: 15,
  },
  {
    path: "/regimes_cpbs",
    perfis: ["ch"],
    component: RegimesTributariosBox,
    recursoId: 16,
  },
  {
    path: "/tipos_recolhimento_iss",
    perfis: ["ch"],
    component: TiposRecolhimentoBox,
    recursoId: 17,
  },
  {
    path: "/graus_instrucao",
    perfis: ["trimap", "prefeitura"],
    component: GrausInstrucaoBox,
    recursoId: 18,
  },
  {
    path: "/naturezas_juridicas",
    perfis: ["ch"],
    component: NaturezasJuridicasBox,
    recursoId: 19,
  },
  {
    path: "/cnaes",
    perfis: ["ch"],
    component: CnaesBox,
    recursoId: 20,
  },
  {
    path: "/feriados",
    perfis: ["trimap", "prefeitura"],
    component: FeriadosBox,
    recursoId: 21,
  },
  {
    tipo: "grade-form",
    path: "/prefeituras",
    perfis: ["trimap"],
    component: PrefeituraBox,
    componentForm: PrefeituraForm,
    recursoId: 22,
  },
  {
    tipo: "grade-form",
    path: "/usuarios",
    perfis: ["trimap"],
    component: UsuariosBox,
    componentForm: UsuariosForm,
    recursoId: 23,
  },
  {
    path: "/servicoslcp",
    perfis: ["trimap", "prefeitura"],
    component: ServicosLCPBox,
    recursoId: 24,
  },
  {
    path: "/categoriaslcp",
    perfis: ["trimap", "prefeitura"],
    component: CategoriasLCPBox,
    recursoId: 25,
  },
  {
    path: "/naturezaoperacao",
    perfis: ["trimap", "prefeitura"],
    component: NaturezasOperacaoBox,
    recursoId: 26,
  },
  {
    path: "/seriesnf",
    perfis: ["trimap", "prefeitura"],
    component: SerieNotaFiscalBox,
    recursoId: 27,
  },
  {
    path: "/retencoesexternas",
    perfis: ["trimap", "prefeitura"],
    component: RetencaoExternaBox,
    recursoId: 28,
  },
  {
    path: "/leis",
    perfis: ["trimap", "prefeitura"],
    component: CadastrarLeisBox,
    recursoId: 29,
  },
  {
    path: "/documentosretencoes",
    perfis: ["trimap", "prefeitura"],
    component: DocumentosRetencaoBox,
    recursoId: 30,
  },
  {
    tipo: "grade-form",
    path: "/cpbs",
    perfis: ["trimap", "prefeitura"],
    component: CpbsBox,
    componentForm: CpbsForm,
    recursoId: 31,
  },
  {
    tipo: "grade-form",
    path: "/valoredificado",
    perfis: ["trimap", "prefeitura"],
    component: ValorEdificadoBox,
    componentForm: ValorEdificadoForm,
    recursoId: 32,
  },
  {
    path: "/agentesrecebedores",
    perfis: ["trimap", "prefeitura"],
    component: AgentesRecebedoresBox,
    recursoId: 33,
  },
  {
    path: "/contascosif",
    perfis: ["trimap", "prefeitura"],
    component: ContasCosifBox,
    recursoId: 34,
  },
  {
    tipo: "grade-form",
    path: "/contascosif",
    perfis: ["trimap", "prefeitura"],
    component: ContasCosifBox,
    componentForm: ContasCosifForm,
    recursoId: 34,
  },
  {
    path: "/statusprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: StatusProtocoloBox,
    recursoId: 35,
  },
  {
    tipo: "grade-form",
    path: "/statusprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: StatusProtocoloBox,
    componentForm: StatusProtocoloForm,
    recursoId: 35,
  },
  {
    path: "/setoratendimentoprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: SetorAtendimentoProtocoloBox,
    recursoId: 36,
  },
  {
    tipo: "grade-form",
    path: "/setoratendimentoprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: SetorAtendimentoProtocoloBox,
    componentForm: SetorAtendimentoProtocoloForm,
    recursoId: 36,
  },
  {
    path: "/tipoprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: TipoProtocoloBox,
    recursoId: 37,
  },
  {
    tipo: "grade-form",
    path: "/tipoprotocolo",
    perfis: ["trimap", "prefeitura"],
    component: TipoProtocoloBox,
    componentForm: TipoProtocoloForm,
    recursoId: 37,
  },
  {
    path: "/recursos",
    perfis: ["trimap", "prefeitura"],
    component: RecursoBox,
    recursoId: 38,
  },
  {
    tipo: "grade-form",
    path: "/parametros_livro_diat",
    perfis: ["trimap", "prefeitura"],
    component: ParametrosLivroBox,
    componentForm: ParametrosLivroForm,
    recursoId: 39,
  },
  {
    path: "/livros-diat",
    perfis: ["trimap", "prefeitura"],
    component: GerarLivroDiat,
  },
  {
    path: "/usuariosprefeitura",
    perfis: ["trimap", "prefeitura"],
    component: UsuariosPrefeituraBox,
  },
  {
    path: "/permissoes",
    perfis: ["trimap", "prefeitura"],
    component: PermissoesBox,
  },
  {
    path: "/auditoria",
    perfis: ["trimap", "prefeitura"],
    component: AuditoriaBox,
  },
  {
    tipo: "grade-form",
    path: "/recursos",
    perfis: ["trimap", "prefeitura"],
    component: RecursoBox,
    componentForm: RecursoForm,
  },
  {
    path: "/gruporecurso",
    perfis: ["trimap", "prefeitura"],
    component: GrupoRecursoBox,
  },
  {
    tipo: "grade-form",
    path: "/gruporecurso",
    perfis: ["trimap", "prefeitura"],
    component: GrupoRecursoBox,
    componentForm: GrupoRecursoForm,
  },
  {
    tipo: "grade-form",
    path: "/textoscda",
    perfis: ["trimap", "prefeitura"],
    component: TextoCdaBox,
    componentForm: TextoCdaForm,
    recursoId: 42,
  },
  {
    path: "/tipos_veiculos",
    perfis: ["trimap", "prefeitura"],
    component: TiposVeiculosBox,
    recursoId: 43
  },
  {
    tipo: "grade-form",
    path: "/situacoesdiat",
    perfis: ["trimap", "prefeitura"],
    component: SituacaoDiatBoxNovo,
    componentForm: SituacaoDiatFormNovo,
    recursoId: 44
  },
  {
    path: "/processar_arquivo",
    perfis: ["trimap", "prefeitura"],
    component: EnviarArquivoProcessamento,
    recursoId: 45
  },
  {
    tipo: "grade-form",
    path: "/lancamentoiptu",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoIptu,
    componentForm: LancamentoIptuForm,
    recursoId: 46
  },
  {
    path: "/acompanhar_iptu/:id",
    perfis: ["trimap", "prefeitura"],
    component: AcompanharIptu,
  },
  {
    tipo: "grade-form",
    path: "/parametrosiptu",
    perfis: ["trimap", "prefeitura"],
    component: ParametrosIptuBox,
    componentForm: ParametrosIptuForm,
    recursoId: 47
  },
  {
    path: "/imprimiriptu",
    perfis: ["trimap", "prefeitura"],
    component: ImprimirIptu,
    recursoId: 48
  },
  {
    tipo: "grade-form",
    path: "/tiposdenotificacoes",
    perfis: ["trimap", "prefeitura"],
    component: TipoNotificacaoBox,
    componentForm: TipoNotificacaoForm,
    recursoId: 49
  },
  {
    tipo: "grade-form",
    path: "/veiculos",
    perfis: ["trimap", "prefeitura"],
    component: VeiculosBox,
    componentForm: VeiculosForm,
    recursoId: 50
  },
  {
    tipo: "grade-form",
    path: "/contasbancarias",
    perfis: ["trimap", "prefeitura"],
    component: ContasBancariasBox,
    componentForm: ContasBancariasForm,
    recursoId: 51
  },
  {
    tipo: "grade-form",
    path: "/receitas",
    perfis: ["trimap", "prefeitura"],
    component: ReceitasBox,
    componentForm: ReceitasForm,
    recursoId: 52
  },
  {
    path: "/unidadesfiscais",
    perfis: ["trimap", "prefeitura"],
    component: UnidadeFiscalBox,
    recursoId: 53
  },
  {
    tipo: "grade-form",
    path: "/contribuintes",
    perfis: ["trimap", "prefeitura"],
    component: ContribuinteBox,
    componentForm: ContribuinteForm,
    recursoId: 54
  },
  {
    tipo: "grade-form",
    path: "/refis",
    perfis: ["trimap", "prefeitura"],
    component: ParametrosRefisBox,
    componentForm: ParametrosRefisForm,
    recursoId: 55
  },
  {
    path: "/indiceprecos",
    perfis: ["trimap", "prefeitura"],
    component: IndicePrecosBox,
    recursoId: 56
  },
  {
    tipo: "grade-form",
    path: "/segmentos",
    perfis: ["trimap", "prefeitura"],
    component: SegmentosBox,
    componentForm: SegmentosForm,
    recursoId: 57
  },
  {
    tipo: "grade-form",
    path: "/fatorescorretivos",
    perfis: ["trimap", "prefeitura"],
    component: FatoresCorretivosBox,
    componentForm: FatoresCorretivosForm,
    recursoId: 58
  },
  {
    tipo: "grade-form",
    path: "/taxas",
    perfis: ["trimap", "prefeitura"],
    component: TaxasBox,
    componentForm: TaxasForm,
    recursoId: 59
  },
  {
    tipo: "grade-form",
    path: "/tipocertidao",
    perfis: ["trimap", "prefeitura"],
    component: ConfiguracaoCndBox,
    componentForm: ConfiguracaoCndForm,
    recursoId: 60
  },
  {
    path: "/motivosisencaoiptu",
    perfis: ["trimap", "prefeitura"],
    component: MotivoIsensaoIptuBox,
    recursoId: 61
  },
  {
    tipo: "rotas-imovel",
    path: "/imoveis",
    perfis: ["trimap", "prefeitura"],
    component: ImovelBox,
    componentForm: ImovelForm,
    componentFormTerreno: FormEditTerreno,
    componentFormEdificacao: FormEditEdificacao,
    componentFormCalculoIptu: CalculoIptu,
    recursoId: 62
  },
  {
    tipo: "grade-form",
    path: "/diat",
    perfis: ["trimap", "prefeitura"],
    component: DiatBox,
    componentForm: DiatForm,
    recursoId: 63
  },
  {
    tipo: "grade-form",
    path: "/notificacaodiat",
    perfis: ["trimap", "prefeitura"],
    component: NotificacaoDiatBox,
    componentForm: NotificacaoDiatForm,
    recursoId: 64
  },
  {
    tipo: "grade-form",
    path: "/entreganotificaodiat",
    perfis: ["trimap", "prefeitura"],
    component: EntregaNotificacaoDiatBox,
    componentForm: EntregaNotificacaoDiatForm,
    recursoId: 65
  },

  {
    tipo: "grade-form",
    path: "/tipos_alvara_construcao",
    perfis: ["trimap", "prefeitura"],
    component: TiposAlvaraConstrucaoBox,
    componentForm: TiposAlvaraConstrucaoForm,
    recursoId: 66
  },
  {
    tipo: "grade-form",
    path: "/alvarasdiversos",
    perfis: ["trimap", "prefeitura"],
    component: TipoAlvaraDiversoBox,
    componentForm: TipoAlvaraDiversoForm,
    recursoId: 67
  },
  {
    tipo: "grade-form",
    path: "/cnaeprefeitura",
    perfis: ["trimap", "prefeitura"],
    component: CnaePrefeituraBox,
    componentForm: CnaePrefeituraForm,
    recursoId: 68
  },
  {
    tipo: "grade-form",
    path: "/lcp116prefeitura",
    perfis: ["trimap", "prefeitura"],
    component: Lcp116PrefeituraBox,
    componentForm: Lcp116PrefeituraForm,
    recursoId: 69
  },
  {
    tipo: "grade-form",
    path: "/cpbs_socios/:inscricao",
    perfis: ["trimap", "prefeitura"],
    component: SociosBox,
    componentForm: SociosForm,
    recursoId: 70
  },
  {
    tipo: "grade-form",
    path: "/formulasiptu",
    perfis: ["trimap", "prefeitura"],
    component: FormulasBox,
    componentForm: FormulasForm,
    recursoId: 71
  },
  {
    tipo: "grade-form",
    path: "/precopublico",
    perfis: ["trimap", "prefeitura"],
    component: PrecoPublicoBox,
    componentForm: PrecoPublicoForm,
    recursoId: 72
  },
  {
    tipo: "grade-form",
    path: "/permissionarios",
    perfis: ["trimap", "prefeitura"],
    component: PermissionarioBox,
    componentForm: PermissionarioForm,
    recursoId: 73
  },
  {
    tipo: "grade-form",
    path: "/responsaveistecnicos",
    perfis: ["trimap", "prefeitura"],
    component: ResponsavelTecnicoBox,
    componentForm: ResponsavelTecnicoForm,
    recursoId: 74
  },
  {
    tipo: "grade-form",
    path: "/certidaonegativa",
    perfis: ["trimap", "prefeitura"],
    component: CertidaoNegativaBox,
    componentForm: CertidaoNegativaForm,
    recursoId: 75
  },
  {
    tipo: "grade-form",
    path: "/itbi",
    perfis: ["trimap", "prefeitura"],
    component: ItbiBox,
    componentForm: ItbiForm,
    recursoId: 76
  },
  {
    tipo: "grade-form",
    path: "/lancamentotaxas",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoTaxasBox,
    componentForm: LancamentoTaxasForm,
    recursoId: 77
  },
  {
    path: "/nfavulsa",
    perfis: ["trimap", "prefeitura"],
    component: NotaFiscalAvulsaBox,
    recursoId: 78
  },
  {
    path: "/emissao_nf_avulsa/:id?",
    perfis: ["trimap", "prefeitura"],
    component: NotaFiscalAvulsaForm,
    recursoId: 78
  },
  {
    tipo: "grade-form",
    path: "/cda",
    perfis: ["trimap", "prefeitura"],
    component: CdaBox,
    componentForm: CdaForm,
    recursoId: 79
  },
  {
    path: "/certidaonegativa/automatica",
    perfis: ["trimap", "prefeitura"],
    component: CertidaoNegativaAutomatica,
    recursoId: 80
  },
  {
    path: "/habitese/:id?",
    perfis: ["trimap", "prefeitura"],
    component: Habitese,
    recursoId: 81
  },
  {
    path: "/arrecadacaogeral",
    perfis: ["trimap", "prefeitura"],
    component: ArrecadacaoGeral,
    recursoId: 82
  },
  {
    path: "/arrecadacaoreceita",
    perfis: ["trimap", "prefeitura"],
    component: ArrecadacaoReceita,
    recursoId: 83
  },
  {
    path: "/arrecadacaocontabilidade",
    perfis: ["trimap", "prefeitura"],
    component: ArrecadacaoContabilidade,
    recursoId: 84
  },
  {
    path: "/relacaodividaativa",
    perfis: ["trimap", "prefeitura"],
    component: RelacaoDividaAtiva,
    recursoId: 85
  },
  {
    path: "/categorialcp116prefeitura",
    perfis: ["trimap", "prefeitura"],
    component: CategoriaLcp116PrefeituraBox,
    recursoId: 86
  },
  {
    path: "/cubo_imoveis",
    perfis: ["trimap", "prefeitura"],
    component: CuboImoveis,
    recursoId: 87
  },
  /*
  Rota removida porque componente está comentado
  {
    path: "/relatorios",
    perfis: ["trimap", "prefeitura"],
    component: RelatoriosDisplay,
    recursoId: 88,
  },
  */
  {
    path: "/arrecadacoes",
    perfis: ["trimap", "prefeitura"],
    component: ArrecadacaoPopup,
    recursoId: 89
  },
  {
    path: "/imovel_inativo",
    perfis: ["trimap", "prefeitura"],
    component: ImoveisInativosPopup,
    recursoId: 90
  },
  {
    path: "/imprimir_imovel",
    perfis: ["trimap", "prefeitura"],
    component: ImprimirImoveisPopup,
    recursoId: 91
  },
  {
    path: "/relatorios_filtros",
    perfis: ["trimap", "prefeitura"],
    component: RelatoriosFiltros,
    recursoId: 92
  },
  {
    path: "/alvara_veiculo/:id?",
    perfis: ["trimap", "prefeitura"],
    component: AlvaraVeiculoForm,
    recursoId: 93
  },
  {
    path: "/alvara_funcionamento/:id?",
    perfis: ["trimap", "prefeitura"],
    component: AlvaraFuncionamentoForm,
    recursoId: 94
  },
  {
    path: "/alvara_sanitario/:id?",
    perfis: ["trimap", "prefeitura"],
    component: AlvaraFuncionamentoForm,
    recursoId: 95
  },
  {
    path: "/dams",
    perfis: ["trimap", "prefeitura"],
    component: DamsBox,
    recursoId: 96
  },
  {
    path: "/cefs",
    perfis: ["trimap", "prefeitura"],
    component: CefsBox,
    recursoId: 97
  },
  {
    path: "/nfse_grade",
    perfis: ["trimap", "prefeitura"],
    component: NfseGradeBox,
    recursoId: 98
  },
  {
    path: "/adn-nfe",
    perfis: ["trimap", "prefeitura"],
    component: AdnNfeBox
  },
  {
    path: "/alvaras",
    perfis: ["trimap", "prefeitura"],
    component: AlvarasBox,
    recursoId: 99
  },
  {
    path: "/baixa_manual",
    perfis: ["trimap", "prefeitura"],
    component: BaixaManualForm,
    recursoId: 100
  },
  {
    path: "/baixarnotas",
    perfis: ["trimap", "prefeitura"],
    component: BaixarNotas,
    recursoId: 101
  },
  {
    path: "/tipos_uso_logradouro_publico",
    perfis: ["trimap", "prefeitura"],
    component: TipoUsoLogradouroBox,
    recursoId: 102
  },
  {
    path: "/alvara_horario_especial/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoAlvaraHorarioEspecial,
    recursoId: 103
  },
  {
    path: "/alvara_logradouro_publico/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoUsoLogradouroPublico,
    recursoId: 104
  },
  {
    path: "/alvara_publicidade/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoAlvaraPublicidade,
    recursoId: 105
  },
  {
    path: "/alvara_diversos/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoAlvaraDiversos,
    recursoId: 106
  },
  {
    path: "/alvara_construcao/:id?",
    perfis: ["trimap", "prefeitura"],
    component: LancamentoAlvaraConstrucao,
    recursoId: 107
  },
  {
    path: "/lancamento_info",
    perfis: ["ch", "prefeitura"],
    recursoId: 108
  },
  {
    path: "/negociacaodiat",
    perfis: ["trimap", "prefeitura"],
    component: NegociacaoDiat,
    recursoId: 109
  },
  {
    path: "/qualificacaosocios",
    perfis: ["trimap", "prefeitura"],
    component: QualificacaoSociosBox,
    recursoId: 110
  },
  {
    path: "/cpbs_cnaes/:inscricao",
    perfis: ["trimap", "prefeitura"],
    component: CnaesCpbsBox,
    recursoId: 111
  },
  {
    path: "/configs",
    perfis: ["trimap", "prefeitura"],
    component: ConfigBox,
    recursoId: 112
  },
  {
    path: "/acompanhardiat",
    perfis: ["trimap", "prefeitura"],
    component: AcompanhamentoDiatBox,
    recursoId: 113
  },
  {
    path: "/calculo-divida-ativa",
    perfis: ["trimap", "prefeitura"],
    component: CalculoManualDiatBox,
    recursoId: 114
  },
  {
    tipo: "grade-form",
    path: "/calculo-divida-ativa",
    perfis: ["trimap", "prefeitura"],
    component: CalculoManualDiatBox,
    componentForm: CalculoManualDiatForm,
    recursoId: 114
  },
  {
    path: "/detalhelancamento/:id?",
    perfis: ["trimap", "prefeitura"],
    component: DetalheLanchamento,
    recursoId: 115
  },
  {
    path: "/acompanharprocessamento/:id?",
    perfis: ["trimap", "prefeitura"],
    component: AcompanharProcessamento,
    recursoId: 116
  },
  {
    path: "/listarprocessamentos/",
    perfis: ["trimap", "prefeitura"],
    component: ListarProcessamento,
    recursoId: 117
  },
  {
    path: "/detalhenfavulsa/:id?",
    perfis: ["trimap", "prefeitura"],
    component: DetalheNFAvulsa,
    recursoId: 118
  },
  {
    path: "/conferenciaacordos",
    perfis: ["trimap", "prefeitura"],
    component: ConferenciaAcordo,
    recursoId: 119
  },
  {
    path: "/prescrever_diat",
    perfis: ["trimap", "prefeitura"],
    component: PrescricaoDiat,
    recursoId: 120
  },
  {
    path: "/faturamento_permissionarios",
    perfis: ["trimap", "prefeitura"],
    component: FaturamentoPermissionarios,
    recursoId: 121
  },
  {
    path: "/protocolo_entrega_notificacao",
    perfis: ["trimap", "prefeitura"],
    component: ProtocoloEntregaNotificacao,
    recursoId: 122
  },
  {
    path: "/criar_processamento",
    perfis: ["trimap", "prefeitura"],
    component: CadastroProcessamentosTeste,
    recursoId: 123
  },
  {
    path: "/analises",
    perfis: ["trimap", "prefeitura"],
    component: AnaliseGraficos,
    recursoId: 124
  },
  {
    path: "/enviar-acessos-em-massa",
    perfis: ["trimap"],
    component: EnviarAcessosEmMassa,
    recursoId: 125
  },
  {
    path: "/arquivos-e-boletos",
    perfis: ["trimap", "prefeitura"],
    component: ArquivosEBoletos,
    recursoId: 126
  },
  {
    path: "/ferramentas-nfse",
    perfis: ["trimap"],
    component: FerramentasNFSe,
    recursoId: 127
  },
  {
    path: "/menu-configuracoes",
    perfis: ["trimap", "prefeitura"],
    component: MenuConfiguracoes,
    recursoId: 128
  },
  {
    path: "/inscricao-manual",
    perfis: ["trimap", "prefeitura"],
    component: DiatFormNovo,
    recursoId: 129
  },
  {
    path: "/enviar-arquivos/:tipo",
    perfis: ["trimap", "prefeitura"],
    component: UploadFiles,
    recursoId: 130
  },
  {
    path: "/extrato-debitos",
    perfis: ["trimap", "prefeitura"],
    component: ExtratoDebitos,
    recursoId: 131
  },
  {
    path: "/nfse",
    perfis: ["trimap", "prefeitura"],
    component: NfseBox,
    recursoId: 132
  },
  {
    path: "/painel-imobiliario",
    perfis: ["trimap", "prefeitura"],
    component: PainelImobiliarioBox,
    recursoId: 133
  },
  {
    path: "/usuarios-prefeitura",
    perfis: ["trimap", "prefeitura"],
    component: UsuariosPrefeituraBox,
    recursoId: 134
  },
  {
    path: "/iss-fixo",
    perfis: ["trimap", "prefeitura"],
    component: IssFixo,
    recursoId: 135
  },
  {
    path: "/simulacoes",
    perfis: ["trimap", "prefeitura"],
    component: Simulacoes,
  },
  {
    path: "/indicestrimap",
    perfis: ["trimap", "prefeitura"],
    component: IndicesTrimapBox,
  },
  {
    path: "/calendarioindicestrimap",
    perfis: ["trimap", "prefeitura"],
    component: CalendarioIndicesTrimapBox,
  },
  {
    path: "/graficos",
    perfis: ["trimap", "prefeitura"],
    component: Graficos,
  },

  {
    path: "/uploadfiles",
    perfis: ["trimap", "prefeitura"],
    component: UploadFiles,
  },

  {
    path: "/relatorio_fat_dec_sn",
    perfis: ["trimap", "prefeitura"],
    component: RelatorioFatDecSn,
  },
  {
    path: "/declaracoes_sn",
    perfis: ["trimap", "prefeitura"],
    component: DeclaracoesSimplesNacional,
  },
  {
    path: "/painel_iss",
    perfis: ["trimap", "prefeitura"],
    component: PainelIssBox,
  },
  {
    path: "/nfse_cpbs",
    perfis: ["trimap", "prefeitura"],
    component: NotasCpbsNfse,
  },
  {
    path: "/espelho_cpbs_nfse",
    perfis: ["trimap", "prefeitura"],
    component: EspelhoCpbsNfse,
  },
  {
    path: "/ranking_nfse",
    perfis: ["trimap", "prefeitura"],
    component: RankingNfse,
  },
  {
    path: "/relatorio-alvaras-emitidos",
    perfis: ["trimap", "prefeitura"],
    component: AlvarasEmitidos,
  },

  {
    path: "/relacao_encerramento_nfse",
    perfis: ["trimap", "prefeitura"],
    component: RelatorioEscrituracoesNfse,
  },
  {
    path: "/remessa_boletos",
    perfis: ["trimap", "prefeitura"],
    component: RegistrarBoletosBox,
  },
  {
    tipo: "grade-form",
    path: "/parametros_pix",
    perfis: ["trimap"],
    component: ParametrosPixBox,
    componentForm: ParametrosPixForm
  },
  {
    tipo: "grade-form",
    path: "/fundamento_legal",
    perfis: ["trimap", "prefeitura"],
    component: FundamentoLegalBox,
    componentForm: FundamentoLegalForm
  },
  {
    path: "/transferencia_imovel",
    perfis: ["trimap", "prefeitura"],
    component: TransferenciaImovel,

    tipo: "grade-form",
    path: "/alvara-em-lote",
    perfis: ["trimap", "prefeitura"],
    component: AlvaraEmLote,
  },
  {
    path: "/restaurar-nf",
    perfis: ["trimap"],
    component: RestaurarNfseBox
  },
  {
    path: "/cancelar-escrituracao",
    perfis: ["trimap"],
    component: CancelarEscrituracaoBox
  },
  {
    path: "/conf_numero_complemento",
    perfis: ["trimap"],
    component: ConferenciaNumeroComplemento
  },
  {
    path: "/conf_logradouro",
    perfis: ["trimap"],
    component: ConferenciaLogradouro
  },
  {
    path: "/transferencia-anual-diat",
    perfis: ["trimap", "prefeitura"],
    component: TransferenciaAnualDiat,
  },
  {
    path: "/unificacaocadastros",
    perfis: ["trimap", "prefeitura"],
    component: UnificarCadastrosForm,
  },
  {
    path: "/premigracaocpbs",
    perfis: ["trimap", "prefeitura"],
    component: PreMigracaoCpbsBox,
  },
  {
    tipo: "grade-form",
    path: "/imovel-bci",
    perfis: ["trimap", "prefeitura"],
    component: ImobelBciBox,
    componentForm: ImovelBciForm,
  },
  {
    path: "/imovel-bci/editar/fatores/:id",
    perfis: ["trimap", "prefeitura"],
    component: ImovelBciFatores,
  },
  {
    tipo: "grade-form",
    path: "/cadastro-modelos",
    perfis: ["trimap"],
    component: CadastroModelosBox,
    componentForm: CadastroModelosForm,
  },
  {
    tipo: "grade-form",
    path: "/cadastro-modelos-prefeitura",
    perfis: ["trimap", "prefeitura"],
    component: CadastroModelosPrefeituraBox,
    componentForm: CadastroModelosPrefeituraForm,
  },
  {
    path: "/certidaonegativa/:id",
    perfis: ["trimap", "prefeitura"],
    component: VisualizarCertidao,
  },
  {
    tipo: "grade-form",
    path: "/encerramento-fiscal",
    perfis: ["trimap", "prefeitura"],
    component: EncerramentoFiscalManualBox,
    componentForm: EncerramentoFiscalManualForm,
  },
  {
    tipo: "grade-form",
    path: "/usuario_nfse/:id?",
    perfis: ["trimap", "prefeitura"],
    component: UsuariosNfseBox,
    componentForm: UsuariosNfseForm,
  },
  {
    path: "/relatorio-arrecadacoes",
    perfis: ["trimap", "prefeitura"],
    component: ArrecadacaoUnificada,
  },
  {
    path: "/acompanhamento-simples-nacional",
    perfis: ["trimap", "prefeitura"],
    component: AcompanhamentoSNBox,
  },
  {
    path: "/procedimento-diat",
    perfis: ["trimap", "prefeitura"],
    component: ProcedimentoDiat,
  },
  {
    path: "/gerar-livro-diat",
    perfis: ["trimap", "prefeitura"],
    component: GerarLivro,
  },
  {
    path: "/simples-nacional",
    perfis: ["trimap", "prefeitura"],
    component: SimplesNacionalBox,
  },
  {
    path: "/protocolos",
    perfis: ["trimap", "prefeitura"],
    component: ProtocolosBox,
  },
  {
    path: "/blazor/*",
    perfis: ["trimap", "prefeitura"],
    component: blazorWrapper,
  },
  {
    tipo: "grade-form",
    path: "/acessos-nfse-antiga",
    perfis: ["trimap"],
    component: AcessosNfseAntigaBox
  },
  {
    path: "/importar-cnpjs-tse",
    perfis: ["trimap"],
    component: ImportarCnpjsTse,
  },
];
